
import { createClient } from '@lumi.new/sdk'

export const lumi = createClient({
    "projectId": "p348973095527010304",
    "apiBaseUrl": "https://api.lumi.new",
    "authOrigin": "https://auth.lumi.new",
})
    